<div class="header-container">
  <div class="logo-container">
    <!-- <a (click)="toggleSidebar()" href="#" class="sidebar-toggle" *ngIf="loginService.isLoggedIn">
    <nb-icon icon="menu-2-outline"></nb-icon>
  </a> -->
  <ingsv-adm-breadcrumbs-menu [list]="navigationService.breadcrumbsMenu"></ingsv-adm-breadcrumbs-menu>
  <a class="logo pl-2" [ngClass]="{'logo-divider': loginService.isLoggedIn}">
    @if (!loginService.isLoggedIn) {
      <span><img src="../../../../assets/images/logo.png" alt="Company logo" width="230"></span>
    }
    @if (loginService.isLoggedIn) {
      <span>
        <!-- TODO: Add logo if needed -->
        <!-- <img *ngIf="accountService.userConfig?.profileData.logo"
        [src]="accountService.userConfig?.profileData.logo"
        alt="logo" />
      <span>{{accountService.getUser().customerData.name}} forsikringstilbud</span> -->
    </span>
  }
</a>
</div>

@if (!env.production) {
  <span class="ml-3 mr-2">
    @if (loginService.isLoggedIn) {
      <nb-select
        class="language-switch-btn"
        [selected]="currentLang"
        (selectedChange)="changeLang($event)"
        status="primary">
        @for (lang of languages; track lang) {
          <nb-option [value]="lang.value">{{ lang.name }}</nb-option>
        }
      </nb-select>
    }
  </span>
}
</div>

@if (loginService.isLoggedIn) {
  <div class="header-container">
    @if (!env.production && loginService.isLoggedIn) {
      <span class="mr-3">
        Du er nå logget inn på et <b>testmiljø</b>
      </span>
    }
    <span [nbContextMenu]="userMenu">{{ 'ROLES.' + roleKey | translate }}</span>
    <ingsv-adm-icons class="ml-1" [icon]="'arrow'" [direction]="'down'"></ingsv-adm-icons>
  </div>
}
